import React from 'react'
import { TabPanels as ChakraTabPanels, TabPanelsProps } from '@chakra-ui/react'

export const TabPanels: React.FC<
  Pick<TabPanelsProps, 'as' | 'sx' | 'children'>
> = props => <ChakraTabPanels {...props} />
